import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectFabricList({ name, brrand }) {
  const isHome = brrand === 'ZaraHome'
  const mapFabric = ({ name: label }) => ({ value: label, label })
  const list = (params) => (isHome ? requests.fabric.listHome(params) : requests.fabric.list(params))

  return (
    <AsyncSearchSelect
      className="grid-cols-1 items-start"
      name={name}
      value={undefined}
      fetchSelected={(selected) => firstOption(list({ selected }), mapFabric)}
      fetchOptions={(search) => asOptions(list({ search, limit: 20 }), mapFabric)}
    />
  )
}
